var events_calendar = (function ($) {

    var _init = function () {
        _update_image_href_with_data_url();
    };

    var _update_image_href_with_data_url = function() {
        $('.deactivate-event-on-archive').each(function() {
            var $event = $(this).closest('.tribe-events-calendar-list__event');
            var $imageLink = $event.find('.tribe-events-calendar-list__event-featured-image-link');

            var eventUrl = $(this).data('website-url');

            if (eventUrl) {
                $imageLink.attr({
                    'href': eventUrl,
                    'target': '_blank'
                });
            }
        });
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = events_calendar;